export const aprMock = {
  recommendations: [
    {
      sku: '300475',
      scenarioStepId: 1,
      modelName: 'SIMILAR_ITEMS',
    },
    {
      sku: '100325',
      scenarioStepId: 1,
      modelName: 'SIMILAR_ITEMS',
    },
    {
      sku: '123779',
      scenarioStepId: 1,
      modelName: 'SIMILAR_ITEMS',
    },
  ],
  size: 3,
  startDt: '1635183267276',
  endDt: '1635183267279',
  scenarioId: 25,
  containerKey: 'home',
  executionId: 'dbba2301 - 8dc0 - 4904 - a4eb - 7ab33a5916e4',
};
